/**
 * Map of file extensions to their corresponding MIME types
 */
export const mimeTypeMap: { [key: string]: string } = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  tiff: 'image/tiff',
};
